module.exports = __webpack_public_path__ + "img/camera.aeb8bb8e.png";